module.exports = __webpack_public_path__ + "img/projects.f9e166c6.svg";